import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import MEDIA_QUERY from '../../styles/emotion/mediaQuery';
import COLORS from '../../styles/emotion/colors';
import ZINDEX from '../../styles/emotion/zIndex';

const openAnimation = keyframes`
  from, 0%, to {
    max-height: 0;
  }
  100%{
    max-height: 100vh;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: ${ZINDEX.super};
  display: flex;
  flex-direction: column;
  align-items: center;
  ${MEDIA_QUERY.MOBILE} {
    align-items: flex-end;
  }
`;

export const ModalDialog = styled.div`
  position: absolute;
  background-color: ${COLORS.WHITE};
  border-radius: 4px;

  ${MEDIA_QUERY.EXCLUDE_MOBILE_XS} {
    top: 100px;
    left: 50%;
    right: auto;
    bottom: auto;
    transform: translateX(-50%);
  }

  ${MEDIA_QUERY.MOBILE} {
    bottom: 0;
    top: auto;
    width: 100%;
    border-radius: 0;

    animation: ${openAnimation} 0.5s ease-in-out;
    margin: auto 0 0 0;
    overflow-y: scroll;
  }
`;

export const CloseModalButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;

  align-self: flex-end;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
  outline: none;
  border: none;
  background: none;
  color: ${COLORS.EMPEROR};
  &:hover {
    color: ${COLORS.LINK_HOVER};
  }
  &:focus {
    outline: highlight auto 2px;
    outline: -webkit-focus-ring-color auto 2px;
  }
  z-index: ${ZINDEX.top};
`;

export const ScreenReaderText = styled.span`
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;
